<template>
  <export-menu @export="handleExport" />
</template>

<script>
import { mapState } from 'vuex';
import ExportMenu from './ExportMenu.vue';
import { exportChartAsPNG, exportAsCSV, generateStackedBarChartSVG } from '../utils/chartExport';
import { exportOTPAsExcel } from '../utils/otpReportExport';

export default {
  name: 'ExportGraph',
  components: {
    ExportMenu,
  },
  props: {
    routes: {
      type: Array,
      required: true,
    },
    dateRange: {
      type: Object,
      required: false,
      default: null,
    },
    threshold: {
      type: Number,
      default: 5,
    },
    filename: {
      type: String,
      default: 'chart',
    },
  },
  computed: {
    ...mapState('otpDashboard', ['filters']),
  },
  methods: {
    handleExport(format) {
      switch (format) {
        case 'png':
          this.exportAsPNG();
          break;
        case 'csv':
          this.exportAsCSV();
          break;
        case 'excel':
          this.exportAsExcel();
          break;
        default:
          console.error('Unknown export format:', format);
      }
    },
    exportAsPNG() {
      const svgContent = generateStackedBarChartSVG(this.routes);

      const chartLikeObject = {
        getSVG: () => svgContent,
        chartWidth: 800,
        chartHeight: this.routes.length * 60 + 40,
      };

      exportChartAsPNG(chartLikeObject, this.filename);
    },
    exportAsCSV() {
      const { headers, rows } = this.prepareRouteDataForExport();
      exportAsCSV(headers, rows, this.filename);
    },
    async exportAsExcel() {
      // Use the OTP report service for Excel export with filters from store
      await exportOTPAsExcel(this.filters, this.routes);
    },
    prepareRouteDataForExport() {
      const headers = ['Route', 'Late (%)', 'On Time (%)', 'Early (%)', 'Skipped (%)'];
      const rows = this.routes.map((route) => [
        route.name,
        route.stats.late,
        route.stats.onTime,
        route.stats.early,
        route.stats.skipped,
      ]);
      return { headers, rows };
    },
  },
};
</script>

<style scoped>
/* Positioning handled by parent */
</style>
